"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormReset(_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream, params = _a.params;
    function reset() {
        ra_fetch_1.Fetcher.api('backend').update('livestreams.reset', params).then(function (response) {
            if (!response.errors.length) {
                setLivestream({
                    name: response.data.name,
                    video: __assign(__assign({}, livestream.video), response.data.video)
                });
            }
        });
    }
    return react_1.default.createElement(storybook_1.Cards.Card, { className: 'mt-4' },
        react_1.default.createElement(storybook_1.Cards.Content, { className: 'flex justify-between items-center py-2' },
            react_1.default.createElement(storybook_1.Texts.Primary, null, "Is jou livestream event afgelopen? Reset dan de naam, omschrijving, thumbnail en wedstrijd data."),
            react_1.default.createElement(storybook_1.Buttons.Button, { onClick: reset, className: 'storybook-button-sized', type: 'light' }, "Reset")));
}
exports.default = FormReset;
